import { raiseError } from '../errors/error';
import lpevents from '../tracking/lpevents';
import { _lp } from './wording';
import baseLink from '../baseLink';
import lpApp from '../app/lp_app';
import {createOrder} from '../manager/apiManager'
import { getExperimentsData } from './utils/experimentsDataHelpers'
import { ENHANCED_CONVERSION_VALUE_BY_PERMALINK } from '../constants/trackingData';
/*
 * LegalPlace payments lib
 */

let Stripe = null;
let braintree = null;
function LpPayment() {
  this.libReady = false;

  // Static count variable
  if(typeof LpPayment.countCallAdwords == 'undefined'){
    LpPayment.countCallAdwords = 0;
  }
  // Requests base url
  this.base_url = baseLink;
  this.config = {

    data_uri: `${this.base_url}/data`,
    stripe: {
      publishableKey: process.env.REACT_APP_STRIPE_KEY,
    },
    paypal: {
      tokenDataUrl: `${this.base_url}/json/paypalToken`,
      submitElem: document.getElementById('paypalSubmit'),
    },
    fetchHeaders: new Headers({
      Origin: 'legalplace.dev',
    }),
  };
  // initing things
  this.Stripe = null;
  this.braintree = null;
  try {
    this.init();
  } catch (err) {
    console.log(err);
  }
}

/*
 * Payment init
 */

LpPayment.prototype.init = function init() {
  // Initializing checkout libraries
  this.initCheckoutLibs().then(() => {
    // State
    const state = {
      stripe: false,
      paypal: false,
    };

    // Initializing Stripe
    this.initStripe().then(() => {
      state.stripe = true;

      if (state.stripe && state.paypal) {
        this.libReady = true;
        console.log('Ready g');
      }
    }).catch((err) => {
      raiseError('credit-error', 21, err.message);
    });

  }).catch(() => {
    raiseError('credit-error', 10, _lp(`Le paiement a échoué en raison d´une erreur inconnue, merci de contacter notre support au ${lpApp.supportPhone}`));
  });
};

/*
 * Initializing Checkout libraries :
 * - Stripe V2
 * - Gateway V3.6.0 for PayPal
 */
LpPayment.prototype.initCheckoutLibs = function initCheckoutLibs() {
  return new Promise((resolve, reject) => {
    let loaded = 0;

    const scriptsList = [
      'https://checkout.stripe.com/checkout.js',
      `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=EUR`,
      'https://js.stripe.com/v2/',
    ];

    scriptsList.forEach((url) => {
      this.loadScript(url).then(() => {
        loaded += 1;
        if (loaded === scriptsList.length) {
          ({ Stripe, braintree } = global);
          resolve();
        }
      }).catch((e) => {
        reject(e);
      });
    });
  });
};

/*
 * Initialize Stripe
 */
LpPayment.prototype.initStripe = function () {
  return new Promise((resolve, reject) => {
    if (typeof (Stripe) === 'undefined') {
      reject(new Error(_lp('Erreur de chargement, veuillez recharger la page')));
    } else {
      Stripe.setPublishableKey(this.config.stripe.publishableKey);
      resolve();
    }
  });
};

/*
 * Handle transaction
 *
 * Expected Data object:
 * {
 *  'pack': (string) chosen pack,
 *  'price': (float) total ttc price,
 *  'locale': (string) current locale (fr_FR|de_DE|etc...)
 *  'option': (object) Option's object,
 *  'invoice': (object) Invoice object,
 *  'contractId': (string) document's id,
 *  'coupon_code': (string) Coupon code,
 *  'type': (srting) payment method[card|paypal],
 *  'card': {
 *    'number': (string) Card number,
 *    'cvc': (string) CVC number,
 *    'exp': (string) Expiration date MM/YY
 *  }
 * }
 */
LpPayment.prototype.handleTransaction = function handleTransaction(data) {
    return new Promise((_resolve, reject) => {

    	// Making sure that the library is ready
    	if(this.libReady !== true && false){
    		reject(new Error(_lp("Erreur de chargement, veuillez recharger la page")));
    		return;
        }

        /**
         * Resolve wrapper function
         *
         * Used to track events & conversions right after
         * a successful payment
         *
         * @param {object} response
         */
        let resolve = (response) => {
          if (typeof LpPayment.countCallAdwords === 'undefined') LpPayment.countCallAdwords = 0
          LpPayment.countCallAdwords ++;
          window.countCall = LpPayment.countCallAdwords;

            try {
              if (LpPayment.countCallAdwords === 1) {
                /**
                 * Tracking Paid event with CHOSEN_PACK & Price
                 */
                lpevents.track('Paid', {
                    "Chosen Pack": data.pack,
                    "Paid Price": data.price
                });
                // Tracking DataLayer
                lpevents.trackGTMFunnel('/checkout', true)

                if (data.price) {
                  lpevents.trackAbTasty('Paid', {
                    revenue: data.revenue,
                    transactionId: lpApp.contractUniqid,
                    transactionTax: data.price*1/6,
                    transactionCoupon: data.coupon_code,
                    paymentMethod: data.paymentMethod,
                    upsell: data.upsell,
                    itemName: lpApp.getState().contract.name,
                    couponCode: data.coupon_code || data.coupon,
                    itemPrice: data.price,
                    uniqid: lpApp.contractUniqid
                  })
                }

                console.log('track paid event')
                lpevents.trackGTMOrder(
                  response.orderId,
                  data.orderShipping && parseFloat(data.orderShipping),
                  data.orderTax && parseFloat(data.orderTax),
                  data.paymentMethod,
                  typeof data.packPriceWithReduction !== 'undefined' && parseFloat(data.packPriceWithReduction),
                  (typeof data.acteProduct === 'boolean' && !data.acteProduct) ? false : true
                )

                let revenue = data.revenue

                if (Object.keys(ENHANCED_CONVERSION_VALUE_BY_PERMALINK).includes(lpApp.contractTitle))
                  revenue = ENHANCED_CONVERSION_VALUE_BY_PERMALINK[lpApp.contractTitle]

                /**
                 * Tracking Adwords conversion
                 */
                lpevents.adwordsConversion({
                    google_conversion_id: 958034329,
                    google_conversion_label: "t7F-CNm6hIoBEJnj6cgD",
                    google_conversion_value: revenue,
                    google_conversion_currency: "EUR"
                });

                /**
                 * Tracking Bing conversion
                 */
                lpevents.bingConversion({
                    gv: parseFloat(data.revenue)
                });

                /**
                 * Tracking Facebook conversion
                 */
                lpevents.facebookConversion({
                    value: parseFloat(data.revenue)
                });

                /**
                 * Tracking Google Analytics conversion
                 */
                lpevents.gAnalyticsConversion({
                    revenue: parseFloat(data.price) / 1.2,
                    price: parseFloat(data.price) / 1.2,
                    name: lpApp.getState().contract.name,
                });
              }
            } catch (error) {
                console.error(error);
            }

            setTimeout(() => {
                _resolve(response);
            }, 2000);
        };

    // Checking data
    try {
      switch (data.type) {
        case 'abonnement':
          this.handleStripeSubscription(data)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              reject(e);
            });

          break;

        case 'card':

          this.handleStripePayment(data)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              reject(e);
            });

          break;

        case 'sepa_debit':
          this.handleSepaDebit(data)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {

              reject(e);
            });

          break;

        case 'paypal':
          this.handlePaypalPayment(data)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              // Notify payment error
              reject(e);
            });

          break;

        default:
          reject(new Error(_lp('Une erreur inconnue est survenue')));
          break;
      }
    } catch (e) {
      reject(new Error(_lp('Une erreur inconnue est survenue')));
    }
  });
};

/*
* Handling Stripe subscription
*/
LpPayment.prototype.handleStripeSubscription = function handleStripeSubscription(data) {
  return new Promise((resolve, reject) => {
    console.log(data);
    // TODO: VALIDATE DATA
    const err = this.stripeDataIsValid(data.card);
    if (typeof (err) === 'object') {
      reject(err);
      return;
    }

    // Initializing form data
    const formElem = document.createElement('form');

    // Card
    const cardElem = document.createElement('input');
    cardElem.setAttribute('data-stripe', 'number');
    cardElem.value = data.card.number;
    formElem.appendChild(cardElem);

    // CVC
    const cvcElem = document.createElement('input');
    cvcElem.setAttribute('data-stripe', 'cvc');
    cvcElem.value = data.card.cvc;
    formElem.appendChild(cvcElem);

    // Expiration
    const expMonth = data.card.exp.split('/')[0].trim();
    const expYear = data.card.exp.split('/')[1].trim();

    // Month
    const expMonthElem = document.createElement('input');
    expMonthElem.setAttribute('data-stripe', 'expMonth');
    expMonthElem.value = expMonth;
    formElem.appendChild(expMonthElem);

    // Year
    const expYearElem = document.createElement('input');
    expYearElem.setAttribute('data-stripe', 'expYear');
    expYearElem.value = expYear;
    formElem.appendChild(expYearElem);

    // Response Handler
    const responseData = data;
    let handleResponse = (code, response) => {
      let errors = [];

      if (code === 200) {
        // Submiting token
        const request = {
          stripeToken: response.id,
          stripeEmail: responseData.client_email,
          paymentMethod: responseData.type,
          coupon: responseData.coupon_code || responseData.coupon,
          is_two_steps: lpApp.getState().contract.is_two_steps,
          experiments_data: getExperimentsData()
        };

        createOrder(responseData.contract_id, request)
          .then(res => {
            const response = res.data
            if (response.STATUS && response.STATUS === 'FAIL') {
              errors = [...this.handleResponseErrors(response.ERROR)];
              reject(errors);
            } else {
              resolve(response);
              return;
            }
          })
          .catch(error => {
            reject(errors);

          })
        return;
      } if ([400, 401, 402, 404, 409, 429].indexOf(code) > -1) {
        // Reading errors
        errors = [...this.handleResponseErrors(response.error)];
      } else {
        errors.push({
          hook: 'global',
          message: _lp(`Une erreur inconnue s'est produite pendant la tentative de débit de votre carte. Veuillez contacter notre support au ${lpApp.supportPhone} ou par email`),
        });
      }

      reject(errors);
    };
    handleResponse = handleResponse.bind(this);

    // Creating Token
    Stripe.card.createToken(formElem, handleResponse);
  });
};


/*
 * Handling Stripe payment
 */
LpPayment.prototype.handleStripePayment = function handleStripePayment(data) {
  return new Promise((resolve, reject) => {
    // Validating Data
    let err = this.stripeDataIsValid(data.card);

    // Checking CGV
    if (!data.cgv) {
      if (typeof (err) !== 'object') err = [];
      err.push({
        hook: 'global',
        message: _lp("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."),
      });
    }

    if (typeof (err) === 'object') {
      reject(err);
      return;
    }

    // Initializing form data
    const formElem = document.createElement('form');

    // Card
    const cardElem = document.createElement('input');
    cardElem.setAttribute('data-stripe', 'number');
    cardElem.value = data.card.number;
    formElem.appendChild(cardElem);

    // CVC
    const cvcElem = document.createElement('input');
    cvcElem.setAttribute('data-stripe', 'cvc');
    cvcElem.value = data.card.cvc;
    formElem.appendChild(cvcElem);

    // Expiration
    const expMonth = data.card.exp.split('/')[0].trim();
    const expYear = data.card.exp.split('/')[1].trim();

    // Month
    const expMonthElem = document.createElement('input');
    expMonthElem.setAttribute('data-stripe', 'expMonth');
    expMonthElem.value = expMonth;
    formElem.appendChild(expMonthElem);

    // Month
    const expYearElem = document.createElement('input');
    expYearElem.setAttribute('data-stripe', 'expYear');
    expYearElem.value = expYear;
    formElem.appendChild(expYearElem);

    // Response Handler
    const responseData = data;
    let handleResponse = (code, response) => {
      let errors = [];
      if (code === 200) {
        // Submiting token
        const request = {
          contract_id: responseData.contract_id,
          pack: responseData.pack,
          options: responseData.options,
          invoice: responseData.invoice,
          upsell: data.upsell,
          coupon: responseData.coupon_code || responseData.coupon,
          stripeToken: response.id,
          paymentMethod: responseData.paymentMethod,
          is_two_steps: lpApp.getState().contract.is_two_steps,
          experiments_data: getExperimentsData()
        };

        if (data.is_installment && data.is_installment === true) request.is_installment = true;

        if (data.is_crea_assist_sub && data.is_crea_assist_sub === true) request.is_crea_assist_sub = true;

        createOrder(responseData.contract_id, request)
          .then(res => {
            const response = res.data
            if (response.STATUS && response.STATUS === 'FAIL') {
              errors = [...this.handleResponseErrors(response.ERROR)];
              reject(errors);
            } else {
              resolve(response);
              return;
            }
          })
          .catch(error => {
            console.error(error)
            reject(errors);

          })
        return;
      } if ([400, 401, 402, 404, 409, 429].indexOf(code) > -1) {
        // Reading errors
        errors = [...this.handleResponseErrors(response.error)];
      } else if ([500, 502, 503, 504].indexOf(code) > -1) {
        // stripe server errors
        errors.push({
          hook: 'global',
          message: _lp(`Une erreur inconnue s'est produite pendant la tentative de débit de votre carte. Veuillez contacter notre support au ${lpApp.supportPhone} ou par email`),
        });
      } else {
        errors.push({
          hook: 'global',
          message: _lp(`Une erreur inconnue s'est produite pendant la tentative de débit de votre carte. Veuillez contacter notre support au ${lpApp.supportPhone} ou par email`),
        });
      }

      reject(errors);
    };
    handleResponse = handleResponse.bind(this);
    // Creating Token
    if (data.cgv) {
      Stripe.card.createToken(formElem, handleResponse);
    }
  });
};


LpPayment.prototype.handleSepaDebit = function handleSepaDebit(data) {


  return new Promise((resolve, reject) => {
    // Response Handler
    const responseData = data;

    let errors = [];
        // Submiting token
        const request = {
          pack: responseData.pack,
          options: responseData.options,
          invoice: responseData.invoice,
          coupon: responseData.coupon_code || responseData.coupon,
          stripeSource: responseData.iban_source.id,
          paymentMethod: responseData.paymentMethod,
          upsell: data.upsell,
          is_two_steps: lpApp.getState().contract.is_two_steps,
          experiments_data: getExperimentsData()

        };
        createOrder(responseData.contract_id, request)
          .then(res => {
            const response = res.data
            if (response.STATUS && response.STATUS === 'FAIL') {
              errors = [...this.handleResponseErrors(response.ERROR)];
              reject(errors);
            } else {
              resolve(response);
              return;
            }
          })
          .catch(error => {
            console.error(error)
            reject(errors);

          })
        return;
  });
};

/*
 * Handling Paypal payment
 */
LpPayment.prototype.handlePaypalPayment = function handlePaypalPayment(data) {
  return new Promise((resolve, reject) => {
    // Checking CGV
    if (!data.cgv) {
      reject(new Error([{
        hook: 'global',
        message: _lp("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."),
      }]));
    }
    // This object will be sent to the server
    const request = {
      contract_id: data.contract_id,
      pack: data.pack,
      options: data.options,
      invoice: data.invoice,
      coupon: data.coupon_code || data.coupon,
      orderId: data.orderId,
      upsell: data.upsell,
      paypalAddress: data.paypalAddress,
      paymentMethod: data.paymentMethod,
      is_two_steps: lpApp.getState().contract.is_two_steps,
      experiments_data: getExperimentsData()
    };
    createOrder(data.contract_id, request)
    .then(response => (resolve(response.data)))
    .catch(() => {
      reject(new Error([{
        hook: 'global',
        message: 'Veuillez réessayer',
      }, {
        hook: 'internal',
        message: err.message,
      }]));
    })
  });
};

/*
 * Helpers
 */

// Load script
LpPayment.prototype.loadScript = function loadScript(url) {
  return new Promise((resolve, reject) => {
    const elem = document.createElement('script');
    elem.setAttribute('src', url);
    document.head.appendChild(elem);

    // Timeout after 15 seconds
    const timeout = setTimeout(() => {
      elem.removeEventListener('load', resolve, false);
      reject(new Error(_lp('Error loading checkout script at: ') + url));
    }, 30000);

    // Listening to load
    elem.addEventListener('load', () => {
      clearTimeout(timeout);
      resolve();
    }, false);
  });
};

// Stripe data validator
LpPayment.prototype.stripeDataIsValid = function stripeDataIsValid(card) {
  const errors = [];

  // Credit card
  if (card.number.replace(/\s+/g, '').length === 0) {
    errors.push({
      hook: 'card.number',
      message: _lp('Veuillez saisir les coordonnées de votre carte de crédit'),
    });
  } else if (!Stripe.card.validateCardNumber(card.number)) {
    errors.push({
      hook: 'card.number',
      message: _lp('Le numéro de carte semble incorrect'),
    });
  }

  // Exp date
  const date = card.exp.split('/');
  if (date) {
    if ((date.length !== 2) || (date[0].trim().length !== 2 || date[1].trim().length !== 2)) {
      errors.push({
        hook: 'card.exp',
        message: _lp('Date invalide'),
      });
    }
  }

  // CVC
  if (card.cvc.trim().length === 0) {
    errors.push({
      hook: 'card.cvc',
      message: _lp('Veuillez saisir votre cryptogramme'),
    });
  } else if (!Stripe.card.validateCVC(card.cvc)) {
    errors.push({
      hook: 'card.cvc',
      message: _lp('Le cryptogramme est incorrect'),
    });
  }

  if (errors.length === 0) return true;
  return errors;
};

/*
 * Helper: Converts object to bullet points
 */
LpPayment.prototype.errorsToBullets = function errorsToBullets(obj) {
  let result = '';
  for (const i in obj) result += `- ${obj[i].message}\n`;
  return result;
};

/*
 * Handling stripe response errors
 */
LpPayment.prototype.handleResponseErrors = function (error) {
  const errors = [];

  switch (error.code) {
    case 'expired_card':
        errors.push({
          hook: 'card.exp',
          message: _lp('Il semble que votre carte soit expirée'),
        });
      break;
    // in case of card error
    case 'invalid_number':
    case 'incorrect_number':
      errors.push({
        hook: 'card.number',
        message: _lp('Le numéro de carte semble incorrect'),
      });
      break;
      // In case of an error with exp date
    case 'invalid_expiry_month':
    case 'invalid_expiry_year':
      errors.push({
        hook: 'card.exp',
        message: _lp("La date d'expiration de votre carte semble incorrecte"),
      });
      break;
      // Fonds insuffisants
    case 'invalid_amount':
    case 'withdrawal_count_limit_exceeded':
      errors.push({
        hook: 'global',
        message: _lp('Il semble que votre carte ait été refusée pour fonds insuffisants'),
      });
      break;
      // CVC invalide
    case 'invalid_cvc':
        errors.push({
          hook: 'card.cvc',
          message: _lp('Le cryptogramme est incorrect'),
        });
        break;
    case 'incorrect_cvc':
    case 'cvc_check_fails':
      errors.push({
        hook: 'card.cvc',
        message: _lp('Le code CVC de votre carte semble incorrect'),
      });
      break;
    case 'card_declined':
      switch (error.decline_code) {
        case 'do_not_honor':
        case 'transaction_not_allowed':
          errors.push({
            'hook': 'global',
            'message': _lp("Votre banque a refusé la transaction pour une erreur inconnue. Vous pouvez contacter notre support au 01 76 35 02 40 ou par email à support@legalplace.fr")
          });
          break;
        case 'insufficient_funds':
          errors.push({
            'hook': 'global',
            'message': _lp("Votre carte ne dispose pas des fonds suffisant pour votre achat.")
          });
          break;
        case 'fraudulent':
        case 'generic_decline':
          errors.push({
            'hook': 'global',
            'message': _lp("Votre paiement a été bloqué car considéré comme trop risqué. Merci d’essayer un autre moyen de paiement ou de nous contacter.")
          });
          break;
        default:
          errors.push({
            'hook': 'global',
            'message': _lp("Une erreur inconnue s\'est produite pendant la tentative de débit de votre carte. Veuillez contacter notre support au 01 76 35 02 40 ou par email")
          });
          break;
      }
      break;
    default:
      errors.push({
        hook: 'global',
        message: _lp(`Une erreur inconnue s'est produite pendant la tentative de débit de votre carte. Veuillez contacter notre support au ${lpApp.supportPhone} ou par email`),
      });
      break;
  }
  return errors;
};

export default LpPayment;



// WEBPACK FOOTER //
// ./src/logic/payment.js